export default "__VITE_ASSET__D7mq4DCP__"